import { Currency } from "components/CustomCurrency/currency";

export function formatTableData(data) {
  console.log(data);
  let rows = [];
  let count = 1;
  data.forEach((elem) => {
    rows.push({
      nro: count,
      empresa: elem.company,
      ventas: <Currency value={elem.total} />,
      quarter1: <Currency value={elem.quarterSales1} />,
      quarter2: <Currency value={elem.quarterSales2} />,
      quarter3: <Currency value={elem.quarterSales3} />,
      quarter4: <Currency value={elem.quarterSales4} />,
    });
    count++;
  });

  return {
    columns: [
      {
        Header: "Nro",
        accessor: "nro",
        width: "5%",
      },
      {
        Header: "Empresa",
        accessor: "empresa",
        width: "40%",
      },
      {
        Header: "Ventas Totales",
        accessor: "ventas",
      },
      {
        Header: "I Trimestre",
        accessor: "quarter1",
      },
      {
        Header: "II Trimestre",
        accessor: "quarter2",
      },
      {
        Header: "III Trimestre",
        accessor: "quarter3",
      },
      {
        Header: "IV Trimestre",
        accessor: "quarter4",
      },
    ],
    rows: rows,
  };
}
